import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { UpdateVehicleRequestPayloadInterface } from "./interfaces";

// const combineUnitsList = (oldUnits: any[], newUnits: any[]) => {
//   let combinedArray = [...oldUnits, ...newUnits].reduce((acc, obj) => {
//     const existingEntry = acc[obj.id];
//     const isVisible = existingEntry?.isVisible ?? obj.isVisible ?? undefined;
//     acc[obj.id] = { ...obj, isVisible };
//     return acc;
//   }, {});

//   combinedArray = Object.values(combinedArray);
//   return combinedArray;
// };

export const mainSlice = createSlice({
  name: "missionsManager",
  initialState,
  reducers: {
    fetchMissionsRequest: (state, _: PayloadAction<any>) => {
      state.isFetchMissionsLoading = true;
    },
    fetchMissionsSuccess: (state, { payload }) => {
      state.missions = payload;
      state.isFetchMissionsLoading = false;
    },
    fetchMissionsError: (state) => {
      state.isFetchMissionsLoading = false;
    },

    fetchMissionRequest: (state, _: PayloadAction<any>) => {
      state.isFetchMissionLoading = true;
    },
    fetchMissionSuccess: (state, { payload }) => {
      state.mission = payload;
      state.isFetchMissionLoading = false;
    },
    fetchMissionError: (state) => {
      state.isFetchMissionLoading = false;
    },

    createMissionRequest: (state, _: PayloadAction<any>) => {
      state.isCreateMissionLoading = true;
    },
    createMissionSuccess: (state, { payload }) => {
      state.mission = payload;
      state.missions = [...state.missions, payload];
      state.isCreateMissionLoading = false;
    },
    createMissionError: (state) => {
      state.isCreateMissionLoading = false;
    },

    runRouteAnalysisRequest: (state, _: PayloadAction<any>) => {
      state.isRunRouteAnalysisLoading = true;
    },
    runRouteAnalysisSuccess: (state, { payload }) => {
      state.mission = payload;
      state.isRunRouteAnalysisLoading = false;
    },
    runRouteAnalysisError: (state) => {
      state.isRunRouteAnalysisLoading = false;
    },

    deleteMissionRequest: (state, _: PayloadAction<any>) => {
      state.isDeleteMissionLoading = true;
    },
    deleteMissionSuccess: (state, { payload }) => {
      state.missions = state.missions.filter(
        (mission) => mission.id !== payload.id
      );
      state.isDeleteMissionLoading = false;
    },
    deleteMissionError: (state) => {
      state.isDeleteMissionLoading = false;
    },

    fetchVehiclesRequest: (state) => {
      state.isFetchVehiclesLoading = true;
    },
    fetchVehiclesSuccess: (state, { payload }) => {
      state.vehicles = payload;
      state.isFetchVehiclesLoading = false;
    },
    fetchVehiclesError: (state) => {
      state.isFetchVehiclesLoading = false;
    },

    updateVehicleRequest: (
      state,
      _: PayloadAction<UpdateVehicleRequestPayloadInterface>
    ) => {
      state.isUpdateVehicleLoading = true;
    },
    updateVehicleSuccess: (state, { payload }) => {
      state.mission = payload;
      state.isUpdateVehicleLoading = false;
    },
    updateVehicleError: (state) => {
      state.isUpdateVehicleLoading = false;
    },

    createVehicleRequest: (state, _: PayloadAction<any>) => {
      state.isCreateVehicleLoading = true;
    },
    createVehicleSuccess: (state, { payload }) => {
      state.mission = payload;
      state.isCreateVehicleLoading = false;
    },
    createVehicleError: (state) => {
      state.isCreateVehicleLoading = false;
    },

    deleteVehicleRequest: (state, _: PayloadAction<any>) => {
      state.isDeleteVehicleLoading = true;
    },
    deleteVehicleSuccess: (state, { payload }) => {
      state.mission = payload;
      state.isDeleteVehicleLoading = false;
    },
    deleteVehicleError: (state) => {
      state.isDeleteVehicleLoading = false;
    },

    setVehicle: (state, { payload }) => {
      if (payload !== undefined)
        state.vehicle = {
          ...state.mission.data.vehicles[payload],
          vehicleIndex: payload
        };
      else {
        state.vehicle = initialState.vehicle;
      }
    },
    clearVehicle: (state) => {
      state.vehicle = initialState.vehicle;
    },
    awaitVehiclePosition: (state, { payload }) => {
      state.vehicle.awaiting_point = payload;
    },
    setVehiclePosition: (state, { payload }) => {
      state.vehicle[state.vehicle.awaiting_point] = payload;
      state.vehicle.awaiting_point = undefined;
    },

    clearMission: (state) => {
      state.mission = initialState.mission;
    },

    restoreDefaultState: () => initialState
  }
});

export const { actions, reducer } = mainSlice;
